import DialogConfirmar from 'global/guides/Dialog/DialogConfirmar'
import { useMutation } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { escalas } from 'service/api/endpoints/escalas'
import { ID } from 'service/api/types'
import { toast } from 'sonner'

function ExcluirAssociacao() {
    const navigate = useNavigate()
    const { pivot, id } = useParams()

    const queryKey = ['escalas', id, 'funcionarios', pivot, 'excluir'] as const

    const { isLoading, mutate } = useMutation(queryKey, exluirAssociacao)

    const handleSubmit = () => {
        mutate(
            { id: id!, pivot: pivot! },
            {
                onSuccess: async () => {
                    await escalas.invalidateQueries({ id: id! })

                    toast.success('Funcionário desassociado da escala')

                    navigate(-1)
                },
                onError: (err: any) => {
                    toast.error(err.message)
                },
            },
        )
    }

    return (
        <DialogConfirmar
            color="error"
            loading={isLoading}
            onConfirm={handleSubmit}
            fecharAoConfirmar={false}
            title="Realmente deseja desassociar o funcionário?"
        />
    )
}

function exluirAssociacao(props: { id: ID; pivot: string }) {
    return escalas.delete(props.id, `funcionarios/${props.pivot}`)
}

export default ExcluirAssociacao
